var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRss = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 81,
  viewBox: "0 0 80 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.5941 69.4619C21.5941 75.3659 16.8081 80.1519 10.9051 80.1519C5.00209 80.1519 0.215088 75.3659 0.215088 69.4619C0.215088 63.5589 5.00109 58.7729 10.9051 58.7729C16.8081 58.7739 21.5941 63.5589 21.5941 69.4619Z",
  fill: "#d5121e"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.215088 27.188V41.969C0.215088 41.969 36.0951 42.971 37.2111 80.153H53.0121C53.0121 80.153 54.8711 29.624 0.215088 27.188Z",
  fill: "#d5121e"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.215088 0.0268555V15.0849C0.215088 15.0849 58.5901 14.1559 65.0961 80.1529H79.7821C79.7821 80.1529 81.4551 4.48886 0.215088 0.0268555Z",
  fill: "#d5121e"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRss);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rss.1e780d7442b587c16a6f120a6e4c2c75.svg";